import { cssTheme } from '@uds/theme-utils';
import { css } from 'linaria';

export const loader = css`
  display: flex;
  justify-content: center;
  padding: ${cssTheme.gu3};
`;
